import React, { type FC, useEffect } from 'react'
import { t } from 'i18next'
import { isEmpty, isNil } from 'lodash'
import { sanitizeHtml } from '@awell/ui-kit/utils'
import { type EmrReportMetadataField } from '../../types'
import { EmrReport } from '../../../../hooks/useEmrDetail/types'

interface Props {
  report: EmrReport
  onLoadEMRReport: (metadata?: Array<EmrReportMetadataField>) => void
}

export const EmrReportTab: FC<Props> = ({ report, onLoadEMRReport }) => {
  useEffect(() => {
    if (!isNil(report?.metadata)) {
      onLoadEMRReport(report.metadata)
    }
  }, [report])

  return (
    <div id="message-preview">
      <div className="text-base text-slate-800">
        {isNil(report?.message_html) && isEmpty(report?.message_html) ? (
          t('message_content_missing')
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(unescape(report.message_html))
            }}
          />
        )}
      </div>
    </div>
  )
}

EmrReportTab.displayName = 'EmrReportTab'
